import { artists } from "@/mocks/gallery";

export default function Artists() {
  return (
    <section id="artists" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
            <i className="ri-user-heart-line"></i>
            Featured Artists
          </span>
          <h2 className="mt-2 font-heading text-2xl font-semibold text-foreground-950 md:text-4xl">
            画师专栏
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm text-foreground-600">
            认识这些用画笔创造温柔世界的创作者,追踪他们的最新动态。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {artists.map((a) => (
            <article
              key={a.id}
              className="rounded-lg bg-background-50 p-5 text-center"
            >
              <div className="relative mx-auto h-20 w-20">
                <img
                  src={a.avatar}
                  alt={`${a.name}·娜美同人画师头像`}
                  className="h-20 w-20 rounded-full border-2 border-primary-200 object-cover"
                />
                <span className="absolute -bottom-1 -right-1 flex h-7 w-7 items-center justify-center rounded-full bg-primary-500 text-background-50">
                  <i className="ri-verified-badge-fill text-sm"></i>
                </span>
              </div>

              <h3 className="mt-3 font-heading text-lg text-foreground-950">{a.name}</h3>
              <p className="text-xs text-foreground-500">{a.alias}</p>

              <span className="mt-3 inline-flex items-center gap-1 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-800">
                <i className="ri-palette-line"></i>
                {a.style}
              </span>

              <div className="mt-4 flex items-center justify-center gap-6 text-xs text-foreground-600">
                <span>
                  <strong className="block text-base text-foreground-900">{a.works}</strong>
                  作品
                </span>
                <span>
                  <strong className="block text-base text-foreground-900">
                    {a.fans >= 1000 ? `${(a.fans / 1000).toFixed(1)}k` : a.fans}
                  </strong>
                  粉丝
                </span>
              </div>

              <p className="mt-3 text-xs leading-relaxed text-foreground-600">{a.intro}</p>

              <button className="mt-4 inline-flex w-full items-center justify-center gap-1.5 rounded-md border border-primary-300 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-500 hover:text-background-50 cursor-pointer whitespace-nowrap">
                进入主页
                <i className="ri-arrow-right-line"></i>
              </button>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}